//
// client-exceptions-routing.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').config(['$routeProvider', '$locationProvider',
        ($routeProvider, $locationProvider) => {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
            }).hashPrefix('!');
            $routeProvider.
                when('/v1/client-exceptions/', {
                    templateUrl: '/templates/client-exceptions/client-exceptions.html',
                    controller: 'ClientExceptionsController',
                }).
                otherwise({
                    redirectTo: '/v1/client-exceptions/',
                });
        },
    ]);
}))();
